<div [class.overlay-hidden]="!show">
  <div class="overlay">
  </div>
</div>